import React from 'react';
import PropTypes from 'prop-types';

import { renderMoreReadableName } from './TaskCreator/renderMoreReadableName';

const ProgressBar = ({
  stages,
  currentStage,
  sections,
  currentSection,
  sectionsData,
  taskType
}) => {
  const completedStepsList = stage => {
    if (sectionsData && sectionsData[stage]) {
      return Object.keys(sectionsData[stage]).map(
        section => sections.indexOf(section) <= sections.indexOf(currentSection)
      );
    }
    return [stages.indexOf(stage) <= stages.indexOf(currentStage)];
  };

  return (
    <div className="progressbar-container">
      <div className="progressbar">
        {stages.map(stage => (
          <ProgressBarStage
            key={stage}
            label={stage}
            completedStepsList={completedStepsList(stage)}
          />
        ))}
      </div>
    </div>
  );
};

const ProgressBarStage = ({ label, completedStepsList }) => (
  <div className="progressbar-stage">
    <label>{renderMoreReadableName(label)}</label>
    <div className="progressbar-stage-indicator">
      {completedStepsList.map((completed, index) => (
        <div
          key={index}
          className={`progressbar-step-indicator ${
            completed ? 'progressbar-step-indicator--completed' : ''
          }`}
        />
      ))}
    </div>
  </div>
);

ProgressBar.propTypes = {
  stages: PropTypes.arrayOf(PropTypes.string),
  currentStage: PropTypes.string.isRequired
};

export default ProgressBar;



// WEBPACK FOOTER //
// ./src/component/ProgressBar.js